import _ from 'lodash'

const defaultModel = (data, headers) => {
	const defaults = data.map(
		({
			id,
			modified,
			title: { rendered: title },
			content: { rendered: content },
			excerpt,
			link,
			type,
			slug,
			acf,
		}) => {
			const regx = /<img[^>]+src\s*=\s*['"]([^'"]+)['"][^>]*>/g
			const regSrcset = /srcset\s*=\s*['"]([^'"]+)['"]/g
			const images = content.match(regx)

			const url = content.match(regSrcset)
			const urlsBySize = (!_.isEmpty(url) && url[0].split('"'))[1] || null

			const srcset = (!_.isEmpty(urlsBySize) && urlsBySize.split(' ')[4]) || null

			const { type: acfType } = acf || {}
			return {
				id,
				type,
				modified,
				slug,
				title,
				content,
				link,
				excerpt: (excerpt && excerpt.rendered) || null,
				image: (!_.isEmpty(images) && images[0]) || null,
				acfType,
				srcset,
			}
		},
	)

	return {
		list: defaults,
		infos: { total: headers['x-wp-total'], totalPages: headers['x-wp-totalpages'] },
	}
}

export default defaultModel
